import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React from "react";
import FileTypeWithExt from "../FileTypeWithExt";
import { useHistory } from "react-router";
import {
  getAdvancedPathWithParam,
  getPathWithParam,
  ROUTES,
  usDateFormat,
} from "../../utils";
import tenantConfig from "../../mocks/tenantOne.json";

const PayrollProgressBar = ({
  payrollDetails,
  setKeyValue,
  keyValue,
  payrollProcess,
  fileType,
}) => {
  const fileInformation = () => {
    setKeyValue(1);
  };
  const errorValidation = () => {
    setKeyValue(2);
  };
  const fileSubmition = () => {
    if (payrollProcess >= 3) {
      setKeyValue(3);
    }
  };
  const payrollFunding = () => {
    if (payrollProcess == 4) {
      setKeyValue(4);
    }
  };
  const history = useHistory();
  const payrollnavigate = () => {
    history.push(
      getAdvancedPathWithParam({
        path: ROUTES.PAYROLL,
        // pathParam: [FLOW_TYPES.ADD],
      })
    );
  };
  return (
    <div
      className="pr-4 pb-4 mb-2"
      style={{ backgroundColor: "#F6F6F6", height: "102vh" }}
    >
      <div
        className="p-4 link primary-small"
        style={{ cursor: "pointer" }}
        onClick={payrollnavigate}
      >
        <FontAwesomeIcon icon={faArrowLeft} style={{ cursor: "pointer" }} />{" "}
        Back
      </div>
      <h4 className="ml-4 mb-3">Payroll</h4>
      <div className="ml-4" style={{ height: "35px" }}>
        <FileTypeWithExt
          fileName={payrollDetails.fileName}
          uploadedThrough={payrollDetails.uploadedThrough}
        />
      </div>
      <div className="ml-4 d-flex mt-2">
        <div className="ft-12 font-weight-500 text-black">
          {moment(new Date(payrollDetails?.uploadedDate)).fromNow()}
        </div>
        <span className="vertical-line mx-2 mb-0" />
        <div className="ft-12 font-weight-500 text-black">
          {moment(new Date(payrollDetails?.uploadedDate)).format("MM/DD/YYYY")}
        </div>
        <div
          style={{ color: "#919191" }}
          className="ft-12 font-weight-500 ml-3"
        >
          {moment(new Date(payrollDetails?.uploadedDate)).format("hh:mm A")}
        </div>
      </div>
      <hr className="ml-4 w-90" />
      <div className="d-flex flex-col">
        <div className="d-flex justify-content-space-around pl-4 pb-2">
          <div className="d-flex flex-col">
            <div
              className="ml-4 mr-4"
              style={{
                backgroundColor: payrollProcess == 1 ? "#067492" : "#06741A",
                borderRadius: "40px",
                width: "32px",
                height: "32px",
                content: "center",
                paddingTop: "6px",
                paddingLeft: "6px",
              }}
            >
              <i
                style={{ color: "white", fontSize: "1.25em" }}
                class={payrollProcess == 1 ? "fa fa-spinner" : "fal fa-check"}
                aria-hidden="true"
              />
            </div>
            <div
              style={{
                borderLeft:
                  payrollProcess == 1
                    ? "3px solid #067492"
                    : "3px solid #06741A",
                height: "20px",
                marginLeft: "38px",
                marginTop: "10px",
              }}
            />
            <div
              style={{
                borderLeft:
                  payrollProcess == 1
                    ? "3px solid #BCBCC0"
                    : "3px solid #06741A",
                height: "30px",
                marginLeft: "38px",
              }}
            />
          </div>
          <div
            onClick={() => {
              fileInformation();
            }}
            className="d-flex flex-col cursor-pointer"
          >
            <span className="grey-text">Step 1</span>
            <span className="font-weight-500">File Information</span>
            <span
              style={{
                border: "1px solid #f5fcff",
                borderRadius: "90px",
                marginTop: "10px",
                textAlign: "center",
                background:
                  "linear-gradient(0deg, rgba(6, 116, 146, 0.1), rgba(6, 116, 146, 0.1)), #FFFFFF",
              }}
            >
              <span
                style={{
                  color: payrollProcess == 1 ? "#067492" : "#06741A",
                  padding: "3px",
                  fontWeight: "600",
                  fontSize: "11px",
                  fontStyle: "normal",
                }}
              >
                {payrollProcess == 1 ? "Processing Fields" : "Completed"}
              </span>
            </span>
          </div>
        </div>

        <div className="d-flex justify-content-space-around pl-4">
          <div className="d-flex flex-col">
            <div
              className="ml-4 mr-4"
              style={{
                backgroundColor:
                  payrollProcess == 2
                    ? "#067492"
                    : payrollProcess >= 2
                    ? "#06741A"
                    : "#919191",
                borderRadius: "40px",
                width: "32px",
                height: "32px",
                content: "center",
                paddingTop: "6px",
                paddingLeft: "6px",
              }}
            >
              <i
                style={{ color: "white", fontSize: "1.25em" }}
                class={
                  payrollProcess == 2
                    ? "fal fa-spinner"
                    : payrollProcess >= 2
                    ? "fal fa-check"
                    : "fal fa-circle"
                }
                aria-hidden="true"
              ></i>
            </div>
            <div
              style={{
                borderLeft:
                  payrollProcess == 2
                    ? "3px solid #067492"
                    : payrollProcess >= 2
                    ? "3px solid #06741A"
                    : "3px solid #BCBCC0",
                height: "20px",
                marginLeft: "38px",
                marginTop: "10px",
              }}
            ></div>
            <div
              style={{
                borderLeft:
                  payrollProcess == 2
                    ? "3px solid #BCBCC0"
                    : payrollProcess >= 2
                    ? "3px solid #06741A"
                    : "3px solid #BCBCC0",
                height: "30px",
                marginLeft: "38px",
              }}
            ></div>
          </div>
          <div
            onClick={() => {
              errorValidation();
            }}
            className="d-flex flex-col cursor-pointer"
          >
            <span className="grey-text">Step 2</span>
            <span className="font-weight-500">Validation & Errors</span>
            <span
              style={{
                border: "1px solid #f5fcff",
                borderRadius: "90px",
                marginTop: "10px",
                textAlign: "center",
                background:
                  payrollProcess == 2
                    ? "linear-gradient(0deg, rgba(6, 116, 146, 0.1), rgba(6, 116, 146, 0.1)), #FFFFFF"
                    : payrollProcess > 2
                    ? "linear-gradient(0deg, rgba(6, 116, 146, 0.1), rgba(6, 116, 146, 0.1)), #FFFFFF"
                    : null,
              }}
            >
              <span
                style={{
                  color: payrollProcess == 2 ? "#067492" : "#06741A",
                  padding: "3px",
                  fontWeight: "600",
                  fontSize: "11px",
                  fontStyle: "normal",
                }}
              >
                {payrollProcess == 2
                  ? "Processing Fields"
                  : payrollProcess >= 2
                  ? "Completed"
                  : null}
              </span>
            </span>
          </div>
        </div>

        <div className="d-flex justify-content-space-around pl-4 pt-2">
          <div className="d-flex flex-col">
            <div
              className="ml-4 mr-4"
              style={{
                backgroundColor:
                  payrollProcess == 3
                    ? "#067492"
                    : payrollProcess >= 3
                    ? "#06741A"
                    : "#919191",
                borderRadius: "40px",
                width: "32px",
                height: "32px",
                content: "center",
                paddingTop: "6px",
                paddingLeft: "6px",
              }}
            >
              <i
                style={{ color: "white", fontSize: "1.25em" }}
                class={
                  payrollProcess == 3
                    ? "fal fa-spinner"
                    : payrollProcess >= 3
                    ? "fal fa-check"
                    : "fal fa-circle"
                }
                aria-hidden="true"
              ></i>
            </div>
            {fileType != 1 &&
              tenantConfig["payrollSubmissionSubMenu"].includes("funding") && (
                <div
                  style={{
                    borderLeft:
                      payrollProcess == 3
                        ? "3px solid #067492"
                        : payrollProcess >= 3
                        ? "3px solid #06741A"
                        : "3px solid #BCBCC0",
                    height: "20px",
                    marginLeft: "38px",
                    marginTop: "10px",
                  }}
                ></div>
              )}
            {fileType != 1 &&
              tenantConfig["payrollSubmissionSubMenu"].includes("funding") && (
                <div
                  style={{
                    borderLeft:
                      payrollProcess == 4
                        ? "3px solid #06741A"
                        : "3px solid #BCBCC0",
                    height: "30px",
                    marginLeft: "38px",
                  }}
                ></div>
              )}
          </div>
          <div
            onClick={() => {
              fileSubmition();
            }}
            className="d-flex flex-col"
          >
            <span className="grey-text">Step 3</span>
            <span className="font-weight-500">File Submission</span>
            <span
              style={{
                border: "1px solid #f5fcff",
                borderRadius: "90px",
                marginTop: "10px",
                textAlign: "center",
                background:
                  payrollProcess == 3
                    ? "linear-gradient(0deg, rgba(6, 116, 146, 0.1), rgba(6, 116, 146, 0.1)), #FFFFFF"
                    : payrollProcess > 3
                    ? "linear-gradient(0deg, rgba(6, 116, 146, 0.1), rgba(6, 116, 146, 0.1)), #FFFFFF"
                    : null,
              }}
            >
              <span
                style={{
                  color: payrollProcess == 3 ? "#067492" : "#06741A",
                  padding: "3px",
                  fontWeight: "600",
                  fontSize: "11px",
                  fontStyle: "normal",
                }}
              >
                {payrollProcess == 3
                  ? "Processing Fields"
                  : payrollProcess >= 3
                  ? "Completed"
                  : null}
              </span>
            </span>
          </div>
        </div>

        {fileType != 1 &&
          tenantConfig["payrollSubmissionSubMenu"].includes("funding") && (
            <div className="d-flex justify-content-space-around pl-4 pt-2">
              <div className="d-flex flex-col">
                <div
                  className="ml-4 mr-4"
                  style={{
                    backgroundColor:
                      payrollProcess == 4 ? "#067492" : "#919191",
                    borderRadius: "40px",
                    width: "32px",
                    height: "32px",
                    content: "center",
                    paddingTop: "6px",
                    paddingLeft: "6px",
                  }}
                >
                  <i
                    style={{ color: "white", fontSize: "1.25em" }}
                    class={
                      payrollProcess == 4 ? "fal fa-spinner" : "fal fa-circle"
                    }
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
              <div
                onClick={() => {
                  payrollFunding();
                }}
                className="d-flex flex-col"
              >
                <span className="grey-text">Step 4</span>
                <span className="font-weight-500">Payroll Funding</span>
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default PayrollProgressBar;
